import { render } from "./reportInfo.vue?vue&type=template&id=2f5af60c&scoped=true"
import script from "./reportInfo.vue?vue&type=script&lang=js"
export * from "./reportInfo.vue?vue&type=script&lang=js"

import "./reportInfo.vue?vue&type=style&index=0&id=2f5af60c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5af60c"]])

export default __exports__